import { Box } from "@mui/material";


export default function Support() {
    return (
        <Box
                sx={{
                position: 'fixed',
                bottom: 16,
                left: 0,
                width: '100%',
                zIndex: 3,
                textAlign: 'center',
                color: '#fff',
                fontSize: 14,
                }}
            >
               
        </Box>
    )
}